import { Alert } from '@/components/react/ui/Alert';
import { ReactIcon } from '@/components/react/ui/ReactIcon';
import { Select } from '@base-ui-components/react/select';
import clsx from 'clsx';
import { useState } from 'react';

interface ReactSelectProps {
  className?: string;
  defaultValue?: string | undefined;
  disabled?: boolean;
  errorMessage: string | null;
  label: string;
  items: {
    label: string;
    value: string;
  }[];
  onValueChange: (value: string, event?: Event) => void;
  placeholder?: string;
  required?: boolean;
}
export const ReactSelect = ({
  className,
  defaultValue,
  disabled = false,
  errorMessage,
  label,
  items,
  onValueChange,
  placeholder,
  required = false,
}: ReactSelectProps) => {
  const [isFilled, setIsFilled] = useState(!!defaultValue);

  return (
    <div className={clsx('group flex w-full flex-col gap-2', className)}>
      <label className="font-semibold" htmlFor="country">
        {label}
      </label>
      <Select.Root
        defaultValue={defaultValue || placeholder}
        disabled={disabled}
        id="country"
        items={items}
        onValueChange={(value) => {
          onValueChange(value || '');
          setIsFilled(true);
        }}
        required={required}
      >
        <Select.Trigger
          className="bg-blurb-bg-input hover:bg-blurb-bg-input-hover data-[popup-open]:border-blurb-border-focus group border-blurb-border-subtle focus:border-blurb-border-focus data-filled:text-blurb-text-bold text-blurb-text-disabled disabled:border-blurb-border-subtle disabed:text-blurb-text-disabled disabled:bg-blurb-bg-neutral-disabled data-invalid:not-data-[popup-open]:border-blurb-border-danger peer relative flex w-full cursor-pointer appearance-none items-center justify-between rounded-sm border p-2 text-left transition-colors duration-150 ease-in focus:outline-none disabled:cursor-not-allowed"
          data-invalid={errorMessage ? 'true' : undefined}
          data-filled={isFilled ? 'true' : undefined}
        >
          <Select.Value className="overflow-hidden text-nowrap overflow-ellipsis" />
          <Select.Icon
            className="text-blurb-text-bold transition-transform duration-250 ease-in group-data-[popup-open]:rotate-180"
            render={<ReactIcon name="chevronDown" size="large" />}
          ></Select.Icon>
        </Select.Trigger>
        <Select.Portal>
          <Select.Positioner alignItemWithTrigger={false} sideOffset={2}>
            <Select.Popup className="bg-blurb-bg-surface scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-400 scrollbar-thumb-rounded shadow-raised group max-h-60 w-[var(--anchor-width)] origin-[var(--transform-origin)] overflow-y-auto rounded-sm transition-[height,opacity] duration-250 ease-in focus-visible:outline-none data-open:p-2 data-[ending-style]:h-0 data-[ending-style]:opacity-0 data-[starting-style]:h-0 data-[starting-style]:opacity-0">
              {items.map(({ label, value }) => (
                <Select.Item
                  key={label}
                  value={value}
                  className="data-highlighted:bg-blurb-bg-input-hover text-blurb-text-bold group relative flex cursor-pointer items-center justify-between rounded-lg p-2 transition-colors duration-150 ease-in focus-visible:outline-none data-selected:font-bold"
                >
                  <Select.ItemText>{label}</Select.ItemText>
                  <Select.ItemIndicator>
                    <ReactIcon name="check" size="large" />
                  </Select.ItemIndicator>
                </Select.Item>
              ))}
            </Select.Popup>
          </Select.Positioner>
        </Select.Portal>
      </Select.Root>
      {errorMessage && <Alert message={errorMessage} />}
    </div>
  );
};
